var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"report"},[_c('div',{staticClass:"report__inner",attrs:{"id":"report"}}),_c('foot-button',[_c('van-button',{attrs:{"type":"primary","block":""},on:{"click":function($event){return _vm.clickDownloadPDF(_vm.getReportUrl)}}},[_vm._v("保存至手机")])],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }